/**
 * Regra de autorização — gestor de reservas.
 *
 * Quem edita atrativos do próprio place e pode criar reserva pay later.
 * O módulo `bookings_admin` autoriza. Sem esse módulo, o atrativo precisa
 * estar na lista do usuário e pertencer ao place dele.
 *
 * @param {object} input
 * @param {object|null} input.params
 * @param {object|null} input.user
 * @param {Array} input.poisList
 * @param {object} input.atrativo
 * @returns {boolean}
 */
export function isReservationManager({
  params,
  user,
  poisList,
  atrativo,
} = {}) {
  if (params == null) {
    return false
  }

  const list = Array.isArray(poisList) ? poisList : []
  const product = atrativo || {}
  const productUuid = String(product.uuid || product.product_uuid || '').toUpperCase()
  const poiIndex = list.findIndex(
    (poi) =>
      String((poi && (poi.uuid || poi.product_uuid)) || '').toUpperCase() ===
      productUuid
  )
  const productPlace = String(
    product.place_uuid ||
      product.placeUUID ||
      product.placeUuid ||
      product.product_place ||
      product.product_place_uuid ||
      ''
  ).toUpperCase()
  const userPlace = String(
    (user && (user.placeUuid || user.place_uuid)) || ''
  ).toUpperCase()
  const isMyProduct = !!(productPlace && userPlace && productPlace === userPlace)

  const modules =
    params != undefined && params.User != undefined
      ? Object.values(params.User.modules)
      : []

  return modules.includes('bookings_admin') || (poiIndex >= 0 && isMyProduct)
}
